import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MDBModalRef } from '../../../app/shared/services/mdb-modal-stub.service';
import { Enums } from '../../shared/models/enums';
import { CellRendererTypes } from '../../shared/widgets/data-grid/enums/cell-renderer.enum';
import { FilterTypes } from '../../shared/widgets/data-grid/enums/filter-types.enum';
import { TableColumn } from '../../shared/widgets/data-grid/interfaces/table-column.interface';


@Injectable()
export class AddCandidatesGridService {
    modalRef: MDBModalRef;
    confirmationStatus = Enums.confirmationStatus;
    private callbackProjDOcUploadModalClose = new Subject<any>(); // Source
    eventCallbackProjDocuUploadModalClose$ = this.callbackProjDOcUploadModalClose.asObservable(); // Stream

    highlightInvalidRecordRenderer(rowData, field) {
        if (rowData[field] !== null) {
            let value = rowData[field];

            if (field === 'trainingDate') {
                value = formatDate(value, 'yyyy-MM-dd', 'en-US');
            }

            if (rowData.recordStatus === null) {
                return `<div><span  title="${value}">${value}</span></div>`;
            } else {
                return `<div class="text-truncate text-red"><span title="${value}">${value}</span></div>`;
            }

        } else {
            return '';
        }

    }
    // Show User Setting Modal

    cols: Array<TableColumn> = [
        {
            field: '',
            header: 'Checkbox',
            pinned: true,
            columnCheckBox: true,
            sort: false,
            style: { 'width': '50px', 'min-width': '50px', 'max-width': '50px' }
        },
        {
            field: 'email',
            header: 'EDGE Exam Applicant Email',
            pinned: true,
            sort: true,
            sortName: 'email',
            filter: { type: FilterTypes.text },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.highlightInvalidRecordRenderer
            }
        },
        {
            field: 'title',
            header: 'Salutation',
            sort: true,
            sortName: 'Salutation',

            //filter: { type: FilterTypes.text },
            //cellRenderer: {
            //    type: CellRendererTypes.html,
            //    renderHtml: this.highlightInvalidRecordRenderer
            //}
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'Mr.', value: 'Mr.' },
                    { label: 'Ms.', value: 'Ms.' },
                    { label: 'Mrs.', value: 'Mrs.' },
                    { label: 'Dr.', value: 'Dr.' }
                ]
            }
        },
        {
            field: 'firstName',
            header: 'First Name',
            sort: true,
            sortName: 'firstName',
            filter: { type: FilterTypes.text },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.highlightInvalidRecordRenderer
            }
        },
        {
            field: 'lastName',
            header: 'Last Name',
            sort: true,
            sortName: 'lastName',
            filter: { type: FilterTypes.text },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.highlightInvalidRecordRenderer
            }
        }, {
            field: 'gender',
            header: 'Gender',
            sort: true,
            sortName: 'Gender',
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'Female', value: 'Female' },
                    { label: 'Male', value: 'Male' },
                    { label: 'Other', value: 'Other' },
                    { label: 'Prefer not to answer', value: 'Prefer not to answer' }
                ]
            }
        },
        {
            field: 'countryName',
            header: 'Country',
            sort: true,
            sortName: 'country',
            filter: { type: FilterTypes.text },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.highlightInvalidRecordRenderer
            }
        },
        {
            field: 'city',
            header: 'City',
            sort: true,
            sortName: 'city',
            filter: { type: FilterTypes.text },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.highlightInvalidRecordRenderer
            }
        },
        {
            field: 'candidateType',
            header: 'Applicant Type',
            sort: true,
            sortName: 'role',
            filter: { type: FilterTypes.text },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.highlightInvalidRecordRenderer
            }
        },
        {
            field: 'faculty1License',
            header: 'EDGE Faculty Id',
            sort: true,
            sortName: 'faculty1License',
            filter: { type: FilterTypes.text },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.highlightInvalidRecordRenderer
            }
        },
        {
            field: 'edgeFaculty1Name',
            header: 'EDGE Faculty',
            sort: true,
            sortName: 'edgeFaculty1',
            filter: { type: FilterTypes.text },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.highlightInvalidRecordRenderer
            }
        },
        {
            field: 'faculty2License',
            header: 'EDGE Second Faculty Id (Optional)',
            sort: true,
            sortName: 'faculty2License',
            filter: { type: FilterTypes.text },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.highlightInvalidRecordRenderer
            }
        },
        {
            field: 'edgeFaculty2Name',
            header: 'EDGE Second Faculty (Optional)',
            sort: true,
            sortName: 'edgeFaculty2',
            filter: { type: FilterTypes.text },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.highlightInvalidRecordRenderer
            }
        },



        //{
        //    field: 'partnerName',
        //    header: 'Training Organization',
        //    sortName: 'partner',
        //    filter: {
        //        type: FilterTypes.select, selectOptions: [
        //            { label: 'All', value: '' },
        //            { label: 'CAMACOL', value: 'CAMACOL' },
        //            { label: 'CEDBIK', value: 'CEDBIK' },
        //            { label: 'GBC Costa Rica', value: 'GBC Costa Rica' },
        //            { label: 'GBC Indonesia', value: 'GBC Indonesia' },
        //            { label: 'GBC South Africa', value: 'GBC South Africa' },
        //            { label: 'GBCI', value: 'GBCI' },
        //            { label: 'IFC', value: 'IFC' },
        //            { label: 'PGBI', value: 'PGBI' },
        //            { label: 'SGS Vietnam', value: 'SGS Vietnam' },
        //            { label: 'Sintali-SGS', value: 'Sintali-SGS' },
        //            { label: 'Other', value: 'Other' }
        //        ]
        //    },
        //    cellRenderer: {
        //        type: CellRendererTypes.html,
        //        renderHtml: this.highlightInvalidRecordRenderer
        //    }
        //},
        //{
        //    field: 'partnerName',
        //    header: 'Training Organization',
        //    sortName: 'partner',
        //    filter: {
        //        type: FilterTypes.select, selectOptions: [
        //            { label: 'All', value: '' },
        //            { label: 'CAMACOL', value: 'CAMACOL' },
        //            { label: 'CEDBIK', value: 'CEDBIK' },
        //            { label: 'GBC Costa Rica', value: 'GBC Costa Rica' },
        //            { label: 'GBC Indonesia', value: 'GBC Indonesia' },
        //            { label: 'GBC South Africa', value: 'GBC South Africa' },
        //            { label: 'GBCI', value: 'GBCI' },
        //            { label: 'IFC', value: 'IFC' },
        //            { label: 'PGBI', value: 'PGBI' },
        //            { label: 'SGS Vietnam', value: 'SGS Vietnam' },
        //            { label: 'Sintali-SGS', value: 'Sintali-SGS' },
        //            { label: 'Other', value: 'Other' }
        //        ]
        //    },
        //    cellRenderer: {
        //        type: CellRendererTypes.html,
        //        renderHtml: this.highlightInvalidRecordRenderer
        //    }
        //},
        {
            field: 'language',
            header: 'Language',
            sortName: 'language',
            filter: { type: FilterTypes.text },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.highlightInvalidRecordRenderer
            }
        },
        {
            field: 'examVersion',
            header: 'Exam Version',
            sort: true,
            sortName: 'examVersion',            
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.highlightInvalidRecordRenderer
            }
        },
        {
            field: 'trainingDate',
            header: 'Training Date',
            sortName: 'trainingDate',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.highlightInvalidRecordRenderer
            }
        },
        {
            field: 'isTrainingCertificateIssuedText',
            header: 'Issue Training Certificate?',   
            sortName: 'isTrainingCertificateIssuedText',
            filter: { type: FilterTypes.text },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.highlightInvalidRecordRenderer
            }
        },
        {
            field: 'recordStatus',
            header: 'Record Status',
            sort: true,
            sortName: 'recordStatus',
            filter: { type: FilterTypes.text },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.highlightInvalidRecordRenderer
            }
        }
    ];
}

